import * as i0 from '@angular/core';
import * as i1 from './window.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/cdk/bidi';
import * as i4 from '@angular/cdk/scrolling';
import * as i5 from '@angular/cdk/overlay';
import * as i6 from '@angular/cdk/portal';
import * as i7 from '../cdk/overlay/mapping';
import * as i8 from '../cdk/overlay/overlay-container';
import * as i9 from '../card/card.component';
import * as i10 from '../card/reveal-card/reveal-card.component';
import * as i11 from '../card/flip-card/flip-card.component';
import * as i12 from '../card/shared/shared.component';
import * as i13 from './windows-container.component';
import * as i14 from './window.component';
import * as i15 from '../cdk/overlay/overlay.module';
import * as i16 from '../card/card.module';
export const NbWindowModuleNgFactory:i0.NgModuleFactory<i1.NbWindowModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.Dir = (<any>(null as any));
var _decl0_12:i4.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_13:i4.CdkScrollable = (<any>(null as any));
var _decl0_14:i4.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_15:i4.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_16:i5.CdkConnectedOverlay = (<any>(null as any));
var _decl0_17:i5.CdkOverlayOrigin = (<any>(null as any));
var _decl0_18:i6.CdkPortal = (<any>(null as any));
var _decl0_19:i6.CdkPortalOutlet = (<any>(null as any));
var _decl0_20:i7.NbPortalDirective = (<any>(null as any));
var _decl0_21:i7.NbPortalOutletDirective = (<any>(null as any));
var _decl0_22:i8.NbOverlayContainerComponent = (<any>(null as any));
var _decl0_23:i9.NbCardComponent = (<any>(null as any));
var _decl0_24:i9.NbCardBodyComponent = (<any>(null as any));
var _decl0_25:i9.NbCardFooterComponent = (<any>(null as any));
var _decl0_26:i9.NbCardHeaderComponent = (<any>(null as any));
var _decl0_27:i10.NbRevealCardComponent = (<any>(null as any));
var _decl0_28:i11.NbFlipCardComponent = (<any>(null as any));
var _decl0_29:i12.NbCardFrontComponent = (<any>(null as any));
var _decl0_30:i12.NbCardBackComponent = (<any>(null as any));
var _decl0_31:i13.NbWindowsContainerComponent = (<any>(null as any));
var _decl0_32:i14.NbWindowComponent = (<any>(null as any));
var _decl0_33:i2.AsyncPipe = (<any>(null as any));
var _decl0_34:i2.UpperCasePipe = (<any>(null as any));
var _decl0_35:i2.LowerCasePipe = (<any>(null as any));
var _decl0_36:i2.JsonPipe = (<any>(null as any));
var _decl0_37:i2.SlicePipe = (<any>(null as any));
var _decl0_38:i2.DecimalPipe = (<any>(null as any));
var _decl0_39:i2.PercentPipe = (<any>(null as any));
var _decl0_40:i2.TitleCasePipe = (<any>(null as any));
var _decl0_41:i2.CurrencyPipe = (<any>(null as any));
var _decl0_42:i2.DatePipe = (<any>(null as any));
var _decl0_43:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_44:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_45:i2.KeyValuePipe = (<any>(null as any));
var _decl0_46:i2.CommonModule = (<any>(null as any));
var _decl0_47:i15.NbOverlayModule = (<any>(null as any));
var _decl0_48:i16.NbCardModule = (<any>(null as any));
var _decl0_49:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_50:i0.ElementRef<any> = (<any>(null as any));
function _View_NbWindowsContainerComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NbWindowsContainerComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_NbWindowComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_32.isFullScreen;
  currVal_0;
  const currVal_1:any = _decl0_32.maximized;
  currVal_1;
  const currVal_2:any = _decl0_32.minimized;
  currVal_2;
}
function _View_NbWindowComponent_2_1():void {
  if (_decl0_32.isFullScreen) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_32.maximize()) !== false);
  }
}
function _View_NbWindowComponent_2_2():void {
  if ((_decl0_32.minimized || _decl0_32.maximized)) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_32.maximizeOrFullScreen()) !== false);
  }
}
function _View_NbWindowComponent_2_3():void {
  if ((_decl0_32.maximized || _decl0_32.isFullScreen)) { var _any:any = (null as any); }
}
function _View_NbWindowComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_23.xxsmall;
  currVal_0;
  const currVal_1:any = _decl0_23.xsmall;
  currVal_1;
  const currVal_2:any = _decl0_23.small;
  currVal_2;
  const currVal_3:any = _decl0_23.medium;
  currVal_3;
  const currVal_4:any = _decl0_23.large;
  currVal_4;
  const currVal_5:any = _decl0_23.xlarge;
  currVal_5;
  const currVal_6:any = _decl0_23.xxlarge;
  currVal_6;
  const currVal_7:any = _decl0_23.active;
  currVal_7;
  const currVal_8:any = _decl0_23.disabled;
  currVal_8;
  const currVal_9:any = _decl0_23.primary;
  currVal_9;
  const currVal_10:any = _decl0_23.info;
  currVal_10;
  const currVal_11:any = _decl0_23.success;
  currVal_11;
  const currVal_12:any = _decl0_23.warning;
  currVal_12;
  const currVal_13:any = _decl0_23.danger;
  currVal_13;
  const currVal_14:any = _decl0_23.hasAccent;
  currVal_14;
  const currVal_15:any = _decl0_23.primaryAccent;
  currVal_15;
  const currVal_16:any = _decl0_23.infoAccent;
  currVal_16;
  const currVal_17:any = _decl0_23.successAccent;
  currVal_17;
  const currVal_18:any = _decl0_23.warningAccent;
  currVal_18;
  const currVal_19:any = _decl0_23.dangerAccent;
  currVal_19;
  const currVal_20:any = _decl0_23.activeAccent;
  currVal_20;
  const currVal_21:any = _decl0_23.disabledAccent;
  currVal_21;
  const currVal_22:any = _decl0_32.config.title;
  currVal_22;
  const currVal_23:any = _decl0_32.isFullScreen;
  currVal_23;
  const currVal_24:any = (_decl0_32.minimized || _decl0_32.maximized);
  currVal_24;
  const currVal_25:any = (_decl0_32.maximized || _decl0_32.isFullScreen);
  currVal_25;
  const pd_26:any = ((<any>_decl0_32.minimize()) !== false);
  const pd_27:any = ((<any>_decl0_32.close()) !== false);
}
